
const BASE_URL = process.env.VUE_APP_API_URL;
const MEDIA_URL = process.env.VUE_APP_MEDIA_URL || '/login';

export default {
  BASE_URL,
  MEDIA_URL,
  endpoints: {
    TOKEN: 'oauth2/token',
    CheckCompanyExists: 'registration/check-company-exists',
    GetSelectBoxValues: 'registration/get-selectbox-values',
    selectBoxValues: 'profile/select-box-values',
    companies: 'profile/companies',
    priorityCompanies: 'profile/priority-companies',
    ServerValidation: 'registration/validate',
    checkMaintenance: 'registration/check-maintenance',
    bloomValidate: 'registration/bloom-validate',
    Register: 'registration',
    bloomRegister: 'registration/bloom-register',
    afterVerifyEmail: 'registration/after-verify-email',
    VerifyEmail: 'registration/verify-email',
    bloomVerifyEmail: 'registration/bloom-verify-email',
    NewVerifyEmail: 'registration/send-verification-link',
    forgotPasswordLink: 'forgot-password/send-reset-link',
    forgotPassword: 'forgot-password',
    profile: 'profile',
    resume: 'profile/preview/resume',
    cv: 'profile/preview/cv',
    LOGOUT: 'profile/logout',
    academic: 'profile/academic',
    employment: 'profile/employment',
    personal: 'profile/personal',
    sharing: 'profile/sharing',
    changePassword: 'profile/change-password',
    changeEmail: 'profile/change-email',
    verifyNewEmail: 'profile/verify-changed-email',
    // verifyNewEmail: 'verify-changed-email',
    changeEmailStatus: 'profile/mass-email-status',
    deleteProfile: 'profile/delete',
    CompanyList: 'companies',
    events: 'all-events',
    event: 'profile/events',
    allMessages: 'contact',
    topMessages: 'contact/unreplied',
    contactDetail: id => `contact/${id}`,
    reply: id => `contact/reply/${id}`,
    changeReadStatus: id => `contact/read/${id}`,
    totalContacts: `contact/total`,
    SITE_INFO: 'site-info',
    unsubscribe: id => `${id}/unsubscribe`,
    VERIFY_2FA: 'verify-2fa',

    //scout function api
    allJobs: 'scout/user-based-jobs',
    initialJobs: 'scout/initial-jobs',
    scoutedJobs: 'scout',
    allJds: 'scout/all-jds',
    addToScout: 'scout/add-to-scout',
    removeFromScout: id => `scouts/${id}`,

  },
  credentials: {
    CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    CLIENT_SECRET: process.env.VUE_APP_CLIENT_SECRET,
    grantTypes: {
      PASSWORD: 'password',
      REFRESH_TOKEN: 'refresh_token',
    },
  },
  url(endpoint) {
    return `${BASE_URL}/${endpoint}`;
  },
};
